import { Grid, Table, TableCell, TableBody, TableRow, TableHead, Typography, Box,  } from '@mui/material';
import React, { Component } from 'react';
import DialogBox from '../../../../container/MUI/DialogBox';
import { isEmpty, sumBy } from "lodash"
import CreditsListUser from '../../../UserView/Credits/CreditsListUser';
import { orderByDsc } from '../../../../store/actions/format';
import axios from 'axios';
import Dialog from '../../../common/Dialog';

class UserCredits extends Component {
    state = { 
        history: [],
        payments: [],
        fetchedUserDebits: false,
        fetchedUserCredits: false,
        totalDebit: 0,
        totalPay: 0,
        totalCredit: 0,
    }
    componentDidMount = () => {
        this.getUserHistory() 
    }


    getUserHistory = async () => {
        const res = await axios.post("/users/credit/history/admin", {userID: this.props.user.user_id}) 
        if (res.data) {
            if (res.data.error) {
                console.log('==== getUserHistory ================');
                console.log(res.data.error);
                console.log('====================================');
            } else {
                let history = orderByDsc(res.data, "credit_date")
                this.setState({
                    history,
                    totalCredit: sumBy(history.filter(cred => cred.type === "credit"), "credit_amount"), 
                    totalDebit: sumBy(history.filter(cred => cred.type === "debit"), "credit_amount"), 
                    fetchedUserCredits: true,
                })
            }
        } else {
            console.log('==== getUserHistory ================');
            console.log("no Response");
            console.log('====================================');
        }

        this.getUserPayments()
    }
    getUserPayments = async () => {
        const res = await axios.post("/users/credit/payments/admin", {userID: this.props.user.user_id}) 
        if (res.data){
            if (res.data.error) {
                console.log('==== getUserPayments ================');
                console.log(res.data.error);
                console.log('====================================');
            } else {
                let payments = orderByDsc(res.data, "payment_date").filter(pay => !pay.is_avance && !isEmpty(pay.payments_spendings))
                this.setState({
                    payments,
                    totalPay: sumBy(payments, "payment_total_amount"),
                    fetchedUserDebits: true
                })
            }
        } else {
            console.log('==== getUserPayments ================');
            console.log("no Response");
            console.log('====================================');
        }
    }

    render() {
        const { history, payments, fetchedUserCredits, fetchedUserDebits, totalCredit, totalDebit, totalPay } = this.state;
        console.log({history, payments, totalCredit, totalDebit, totalPay});
        let debit = totalPay + totalDebit
        return (
            <Box>
                {fetchedUserCredits && fetchedUserDebits &&
                    <CreditsListUser
                        USER_CREDITS={history}
                        USER_PAYMENTS={payments}
                        totalDebit={debit}
                        totalCredit={totalCredit}
                        handleCloseAll={this.props.handleClose}
                        {...this.props}
                        admin
                    />
                }
            </Box>
            
        );
    }
}

export default UserCredits;